export default __webpack_public_path__ + "static/media/online_everywhere.80485e56.svg";